export default "__VITE_ASSET__2b0133d9__"